import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import {
  RequestTypes,
  permitTemplatesKeys,
} from '@core/react-query/features/templates/permitTemplates'
import {
  IPermitTemplateRole,
  PermitTemplateRole,
} from '@core/entities/permit/PermitTemplateRoles'

const transform = (response: IPermitTemplateRole[]) =>
  response.map(PermitTemplateRole.new)

export const useGetPermitTemplateRolesByProject = (
  payload: RequestTypes['getPermitTemplateRolesByProject'],
  options?: UseQueryOptions<
    IPermitTemplateRole[],
    string,
    PermitTemplateRole[]
  >,
) =>
  useQuery({
    select: transform,
    ...permitTemplatesKeys.getRolesByProject(payload),
    ...options,
  })
